import { fromJS } from 'immutable'
import { STYLES } from 'components/Row.v2'
import {
  DISPLAY_MODE_TILE_LIST_TOP_TEN,
  DISPLAY_MODE_TILE_LIST_TOP_TEN_3X4,
} from 'services/pm-section'

/**
 * Returns the appropriate row style based on the display mode.
 *
 * @param {string} displayMode - The current display mode.
 * @returns {string} - The corresponding row style.
 */
export function getRowStyle (displayMode) {
  if (displayMode === DISPLAY_MODE_TILE_LIST_TOP_TEN) {
    return STYLES.TILES_TOP_TEN
  }
  if (displayMode === DISPLAY_MODE_TILE_LIST_TOP_TEN_3X4) {
    return STYLES.TILES_TOP_TEN_VERTICAL
  }
  return STYLES.S12345
}

/**
 * Gets the view all link configuration.
 *
 * @param {Object} options - The options object.
 * @param {Map} options.viewAllLink - The current view all link.
 * @param {Object} options.sectionConfig - The section configuration.
 * @param {Map} options.staticText - The static text.
 * @returns {Map|null} - The view all link configuration or null if not found.
 */
export function getViewAll ({ viewAllLink, sectionConfig, staticText }) {
  if (viewAllLink.get('url') && viewAllLink.get('label')) {
    return viewAllLink
  }
  if (sectionConfig.viewAll) {
    const linkConfig = sectionConfig.viewAll[0]
    return fromJS({
      ...linkConfig,
      label: staticText.get(linkConfig.linkTextKey),
    })
  }
  return null
}
